<template lang="pug">
  v-dialog(v-model="isModalVisible" width='600px')
    v-card.ld-upgrade-product
      v-card-title Subscribe to CRM and Landing Pages
      v-card-text.pb-0
        v-container.ma-0.pa-0
          v-layout(justify-center).ma-0
            v-flex.ma-0.pa-0.xs2.text-xs-center
              div.logo
                div(:style="{ backgroundImage: `url('${logoURL}')` }")
              p.primary--text CRM
            v-flex.ma-0.pa-0.xs1.text-xs-center
              div.plus-sign.primary--text
                span +
            v-flex.ma-0.pa-0.xs2.text-xs-center
              v-icon.landing-pages(size='40px', color='primary') menu_book
              p.primary--text Landing Pages
        video.mb-2.video(
          width="450px"
          controls
        )
          source(
            src="https://ld-marketing.s3.us-west-2.amazonaws.com/video_ui_landingpages.mp4"
            type="video/mp4"
          )
        p Do not want to lose a lead captured from landing pages after your trial has expired? Automate
          |  tagging and starting campiagns with LionDesk CRM.
        p.mb-0 #[strong Save up to 20%] by purchasing both CRM and Landing Pages together. 
          | #[strong Offer available for trial users only.]
        h3.primary--text.text-xs-center Your Landing Page Subscription Includes
        ul.features-list
          li.mt-1(v-for="(feature, index) in featuresList" :key="index") {{ feature }}
        p.mt-2.m2-0.caption.font-italic *Landing Pages is only available with a LionDesk subscription.
      v-card-actions.pa-3
        v-spacer.grow
        v-btn(color='primary' flat @click='isModalVisible = false') Cancel
        v-btn(color='primary' @click='v1LandingPagesRedirect') Claim My Offer

</template>

<script>
import baseLogo from 'lion-vue-assets/liondesk-logo.png';

export default {
  name: 'TrialUpgradeModal',
  data() {
    return {
      logoURL: baseLogo,
      dialog: true,
      featuresList: [
        'Drag and drop page design',
        'High converting templates',
        'Mobile responsive pages',
        'Leads automatically connected to LionDesk',
        'Works great with LionDesk Facebook Ads',
        'Unlimited published pages',
        'Lightning fast page loads',
        'SEO optimization',
      ],
    }
  },
  computed: {
    isModalVisible: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) this.$emit('hide');
        return this.dialog = value;
      },
    },
  },
  methods: {
    v1LandingPagesRedirect() {
      window.open(process.env.VUE_APP_V1_LANDING_PAGES_URL, '_blank')
      this.isModalVisible = false;
    }
  }
}
</script>
<style lang="scss" scoped>
  .features-list {
    margin-left: 150px;
  }
  .logo {
    height: 50px;
    width: 50px;
    display: inline-block;
    div {
      height: 50px;
      width: 50px;
      background-size: contain;
      display: inline-block;
    }
  }
  .plus-sign {
    width: 50px;
    height: 50px;
    display: inline-block;
    font-size: 40px;
    vertical-align: middle;
  }
  .landing-pages {
    margin-bottom: 14px;
  }
  .ld-upgrade-product {
    font-size: 12px;
  }
  .video {
    margin: 0 auto;
    display: block;
  }
  
</style>